<template>
  <v-tag-select-search
    :selectedTags="draft.tags"
    :unselectedTags="unselectedTags"
    :supportsMatchType="supportsMatchType"
    :matchType="draft.matchType"
    @change="onTagChange"
    @matchTypeChange="onMatchTypeChange"
  />
</template>

<script>
import { mapState } from 'vuex';
import VTagSelectSearch from '@/components/v3/elements/VTagSelectSearch';
import { TagMatchType } from '@/util/constants';

export const defaultTagFilter = () => ({ tags: [], matchType: TagMatchType.ALL });

export default {
  name: 'EzTagsFilter',
  components: {
    VTagSelectSearch,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    value: {
      type: Object,
      default: defaultTagFilter,
    },
    supportsMatchType: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
    },
  },
  data() {
    return {
      draft: defaultTagFilter(),
    };
  },
  computed: {
    ...mapState('tags', ['allTags']),
    draftTagIds() {
      return this.draft.tags.map(item => item.id);
    },
    unselectedTags() {
      return this.allTags.filter(item => this.draftTagIds.indexOf(item.id) === -1);
    },
  },
  watch: {
    value: {
      handler() {
        this.revert();
      },
      deep: true,
    },
  },
  methods: {
    /**
     * Read the current draft. The consumer calls this when the user applies.
     */
    getValue() {
      return {
        tags: [...this.draft.tags],
        matchType: this.draft.matchType,
      };
    },
    /**
     * Discard edits and re-seed from the applied value. Only needed if the
     * component stays mounted while the filter UI is closed.
     */
    revert() {
      this.draft = {
        tags: [...(this.value.tags || [])],
        matchType: this.value.matchType || TagMatchType.ALL,
      };
    },
    onTagChange({ tag, isUnselect }) {
      const tags = isUnselect
        ? this.draft.tags.filter(item => item.id !== tag.id)
        : [...this.draft.tags, tag].sort((a, b) => a.priority - b.priority);
      this.draft = { ...this.draft, tags };
      this.$emit('draftChange', this.getValue());
    },
    onMatchTypeChange(matchType) {
      this.draft = { ...this.draft, matchType };
      this.$emit('draftChange', this.getValue());
    },
  },
  created() {
    this.revert();
  },
};
</script>

<style scoped lang="scss">
</style>
